import { useState, useRef, useEffect } from "react"
import { NavbarLinks } from "./navbar/NavbarLinks"
import { NavbarActionItems } from "./navbar/NavbarActionItems"
import { Link } from "react-router-dom"
import "./navbar.css"

export function Navbar() {
    const [isSticky, setIsSticky] = useState(false)

    const navbarRef = useRef()

    useEffect(() => {
        window.addEventListener("scroll", () => {
            if (window.scrollY > 100) {
                setIsSticky(true)
            } else {
                setIsSticky(false)
            }
        })
    })

    return (
        <div
            ref={navbarRef}
            className={"d-flex align-items-center mx-auto nav-bar " + (isSticky ? "sticky" : "")}>

                <div className="w-25 lg-vsbl">
                    <Link to="/" className="site-logo">Exclusive</Link>
                </div>

                <NavbarLinks />
                <NavbarActionItems />

        </div>
    )
}